module.exports = __webpack_public_path__ + "static/media/e-up.2692152b.png";